module.exports = __webpack_public_path__ + "static/media/56.fecb660e.jpg";